import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../../components/Common/TableContainer";
import PdfIframeViewer from "common/pdf-iframe-viewer";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchCategory, fetchDepartment, getpaySlipdetails, clearapproveError1 } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomDatePicker from "common/CustomDatePicker";
import useButtonAccess from "components/Common/useButtonAccess";
import classnames from "classnames";
import Loader from "common/pageLoader";
import { useDispatch, useSelector } from "react-redux";
import PayslipList from "../MyPayslip/PayslipList";
import "../MyPayslip/Payslip.css";
import Swal from 'sweetalert2';

const PayrollReportPayslip = () => {
  const columns = []
  const [fileUrl, setFileUrl] = useState("https://css4.pub/2015/icelandic/dictionary.pdf");
  const dispatch = useDispatch();
  const [accessRight, setAccessRight] = useState(null);
  const [authDetails, setAuthDetails] = useState(null);
  const [data, setdata1] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    dispatch(fetchCategory(authUserDetails[0].unit_id));
    dispatch(fetchDepartment(authUserDetails[0].unit_id));
  }, [dispatch]);

  const {
    employees,
    categoryList,
    departmentList,
    payslipdetails,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    payslipdetails: state.PayrollReportsReducer?.payslipdetails ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.AttendanceLeaveManagReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
  }));

  let categoryOptions = [], deptOptions = [];

  categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));

  const formik = useFormik({
    initialValues: {
      category: "",
      salaryMonth: "",
      department: "",
    },
    validationSchema: Yup.object({
      salaryMonth: Yup.string().nullable().typeError("Month is required").required("Month is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("saldate", values.salaryMonth);
      formData.append("cat_id", values.category?.value || 0);
      formData.append("dept_id", values.department?.value || 0);
      formData.append("emp_id", 0);
      dispatch(getpaySlipdetails(formData));
    },
  });

  const resetFormData = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    formik.resetForm({
      values: {
        category: "",
        department: "",
        salaryMonth: "",
      },
    });
  };

  useEffect(() => {
    return () => {
      dispatch(clearapproveError1());
    };
  }, []);

  return (
    <React.Fragment>
      <Loader loading={loading} />
      <div className="page-content">
        <Container fluid>
          <div className="no-print">
            <Breadcrumbs title="Payroll / Reports / Salary Reports" breadcrumbItem="Pay Slip" />
            <Card>
              <CardBody>
                <Form onSubmit={formik.handleSubmit}>
                  <Row className="gy-3">
                    <Col md={3}>
                      <Label>Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        isMulti={false}
                        options={categoryOptions || []}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("category", selectedOption);
                        }}
                        onBlur={() => formik.setFieldTouched("category", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable={true}
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </Col>

                    <Col md={3}>
                      <Label>Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        isMulti={false}
                        options={deptOptions || []}
                        value={formik.values.department || null}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("department", selectedOption);
                        }}
                        onBlur={() => formik.setFieldTouched("department", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable={true}
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </Col>
                    <Col md={2}>
                      <Label>Salary Month <span className="text-danger">*</span></Label>
                      <CustomMonthPicker
                        name="salaryMonth"
                        value={formik.values.salaryMonth}
                        onChange={(date) => {
                          formik.setFieldValue("salaryMonth", date);
                        }}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.salaryMonth && formik.errors.salaryMonth ? "is-invalid" : ""}`}
                      />
                      {formik.touched.salaryMonth && formik.errors.salaryMonth && (
                        <div className="text-danger">{formik.errors.salaryMonth}</div>
                      )}
                    </Col>

                    <Col md={3} className="text-end d-flex align-items-center gap-2 mt-5">
                      <Button type="submit" color="primary" className="px-3 d-flex align-items-center"><i className="fas fa-search me-2"></i> SEARCH </Button>
                      <Button color="danger" className="px-3 d-flex align-items-center no-print" onClick={() => window.print()}>  <i className="fas fa-print me-2"></i>  PRINT</Button>
                      {/* <Button type="reset" color="secondary" className="px-3 d-flex align-items-center" onClick={resetFormData}> <i className="fas fa-sync me-2"></i> CANCEL</Button> */}
                      <Button type="reset" className="btn button-cancel"
                        onClick={() => {
                          Swal.fire({
                            title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                            showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                          }).then((result) => {
                            if (result.isConfirmed) {
                              resetFormData();
                            }
                          });
                        }}
                      >
                        <i className="fas fa-sync me-1" /> CANCEL
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </div>

          {/* PDF Viewer Section */}

          <Card>
            <CardBody>
              <div className="payslip-print">
                {payslipdetails && payslipdetails.length > 0 ? (
                  <PayslipList employees={payslipdetails} />
                ) : (
                  <div className="text-center text-muted py-4">
                    <i className="fas fa-info-circle fa-2x mb-2" />
                    <p className="mb-0">No Records Found</p>
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollReportPayslip;
